import _ from 'lodash';

export const getYears = (prevDif, nextDif) => {
    const years = [];
    const today = new Date();
    const nowYear = today.getFullYear();

    const firstYear = Number(nowYear) - Number(prevDif);
    const lastYear = Number(nowYear) + Number(nextDif);

    for (let index = firstYear; index <= lastYear; index++) {
        years.push(index);
    }

    return years;
}

export const getHeadquarterGoalsMonths = (headquarters) => {
    let goalsData = [];
    headquarters.forEach(headquarter => {
        let data = { id: headquarter.id, dptNm: headquarter.name };
        for (let index = 1; index < 13; index++) {
            let goal = Math.floor(Math.random() * 1000);
            data[index] = goal;
        };

        goalsData.push(data);
    });


    return goalsData;
}


export const getHeadquarterMonthsData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, results: [], goals: [] };
        for (let index = 1; index < 13; index++) {
            let goal = Math.floor(Math.random() * 1000);
            data.goals.push({ [index]: goal })

            let result = Math.floor(Math.random() * 1000);
            data.results.push({ [index]: result })
        };
        rows.push(data);

    });


    return rows;
}



export const getHeadquarterQuarterData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, results: [], goals: [] };
        for (let index = 1; index < 5; index++) {
            let goal = Math.floor(Math.random() * 1000);
            data.goals.push({ [index]: goal })

            let result = Math.floor(Math.random() * 1000);
            data.results.push({ [index]: result })
        };
        rows.push(data);

    });
    return rows;
}


export const getHeadquarterMonthsChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 12; index++) {
        let object = { name: index + 1 + "월" };
        object['goal'] = data.goals[index][index + 1];
        object['result'] = data.results[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}



export const getHeadquarterQuartersChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 4; index++) {
        let object = { name: index + 1 + "분기" };
        object['goal'] = data.goals[index][index + 1];
        object['result'] = data.results[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}

export const getQuarters = () => {
    const quarters = [];
    for (let index = 1; index < 5; index++) {
        quarters.push(index);
    };
    return quarters;
}

export const getMonths = () => {
    const months = [];
    for (let index = 1; index < 13; index++) {
        months.push(index);
    };
    return months;
}


export const getHeadquarterMonthsSalesData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, chances: [], estimates: [], orders: [] };
        for (let index = 1; index < 13; index++) {
            let chance = Math.floor(Math.random() * 100);
            data.chances.push({ [index]: chance });

            let estimate = Math.floor(Math.random() * 100);
            data.estimates.push({ [index]: estimate });

            let order = Math.floor(Math.random() * 100);
            data.orders.push({ [index]: order })
        };
        rows.push(data);

    });


    return rows;
};

export const getHeadquarterMonthsSalesChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 12; index++) {
        let object = { name: index + 1 + "월" };
        object['chance'] = data.chances[index][index + 1];
        object['estimate'] = data.estimates[index][index + 1];
        object['order'] = data.orders[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}

export const getHeadquarterQuarterSalesData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, chances: [], estimates: [], orders: [] };
        for (let index = 1; index < 5; index++) {
            let chance = Math.floor(Math.random() * 100);
            data.chances.push({ [index]: chance })

            let estimate = Math.floor(Math.random() * 100);
            data.estimates.push({ [index]: estimate })

            let order = Math.floor(Math.random() * 100);
            data.orders.push({ [index]: order })
        };
        rows.push(data);

    });
    return rows;
}

export const getHeadquarterQuartersSalesChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 4; index++) {
        let object = { name: index + 1 + "분기" };
        object['chance'] = data.chances[index][index + 1];
        object['estimate'] = data.estimates[index][index + 1];
        object['order'] = data.orders[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}

export const initGoalData = () => {
    let months = [];
    for (let index = 0; index < 12; index++) {
        let newObject = { month: index + 1, ptargetSales: '', ptargetSalesProfit: '', mtargetSales: '', mtargetSalesProfit: '' };
        months.push(newObject);
    }
    return months;
}

export const initPrjGoalData = () => {
    let months = [];
    for (let index = 0; index < 12; index++) {
        // 2026-10-23 (250423 피드백 #5): 저장된 값이 없을 때도 기본 배분비율(monthPercent)을
        // 미리 채워 월별 % 합계가 처음부터 100%가 되도록 한다(빈 값이면 합계가 0%라
        // 바로 저장이 막혀버림).
        let newObject = { month: index + 1, ptargetSales: '', ptargetSalesProfit: '', pct: monthPercent[index] };
        months.push(newObject);
    }
    return months;
};

export const monthPercent = [
    5,
    5,
    5,
    5,
    5,
    15,
    5,
    10,
    10,
    10,
    10,
    15
];

// 2026-10-23 (250423 피드백 #5 "배부 비율 조정"): 연간 총액 + 월별 비율(%)로 월별
// 금액을 계산한다. 사용자가 월별 %를 직접 입력했을 때 쓰는 단순 계산 — 각 달을
// 독립적으로 반올림한다(달마다 ±1원 수준의 반올림 오차는 허용, 12월에 강제로
// 끌어모으지 않는다 — 그건 자동배분 전용 로직).
export const calcMonthAmountsByPct = (totalSales, totalProfit, pctArray) => {
    const total = Number(totalSales) || 0;
    const totalProfitNum = Number(totalProfit) || 0;
    let months = [];
    for (let index = 0; index < 12; index++) {
        const pct = pctArray?.[index] !== undefined && pctArray[index] !== null && pctArray[index] !== ''
            ? Number(pctArray[index])
            : 0;
        months.push({
            month: index + 1,
            pct,
            ptargetSales: Math.round(total * (pct / 100)),
            ptargetSalesProfit: Math.round(totalProfitNum * (pct / 100)),
        });
    }
    return months;
};

// 자동배분: 기본 비율(monthPercent)로 되돌리면서 월별 금액을 계산한다. 비율 합이
// 정수라 100%가 정확히 맞지만, 원 단위 반올림 오차가 생길 수 있어 "0.1% 반올림
// 처리"로 마지막 달이 잔차를 흡수해 총액과 월별 합계가 원 단위까지 정확히 일치하게
// 맞춘다(수동 편집에는 적용하지 않음 — 사용자가 직접 입력한 다른 달 금액을 임의로
// 건드리지 않기 위해서다).
export const autoDistributeMonthGoals = (totalSales, totalProfit) => {
    const months = calcMonthAmountsByPct(totalSales, totalProfit, monthPercent);
    const salesSumExceptLast = _.sumBy(months.slice(0, 11), 'ptargetSales');
    const profitSumExceptLast = _.sumBy(months.slice(0, 11), 'ptargetSalesProfit');
    months[11] = {
        ...months[11],
        ptargetSales: (Number(totalSales) || 0) - salesSumExceptLast,
        ptargetSalesProfit: (Number(totalProfit) || 0) - profitSumExceptLast,
    };
    return months;
};

// 월별 % 합계를 2자리까지 반올림해서 돌려준다(부동소수점 오차 방지 — 0.1%+0.1%+...가
// 99.99999999가 되는 걸 막는다). 저장 가능 여부는 이 값이 정확히 100인지로 판단한다.
export const sumMonthPct = (monthGoals) => {
    const sum = _.sumBy(monthGoals, (g) => Number(g.pct) || 0);
    return Math.round(sum * 100) / 100;
};

